"use strict";

// require('intersection-observer');
// var Scrollama = require('scrollama');
const _ = require("lodash");
const Cookies = require("js-cookie");
const ResponsiveUtility = require("./components.js").ResponsiveUtility;

class Global {
  // prevent a cross-site hack where they can impersonate your website
  addNoopener() {
    $('a[target="_blank"]').each(function () {
      $(this).attr("rel", "noopener");
    });
  }

  // when the user starts to press the tab key
  // we add a class to the website which will help
  // clearly highlight what is currently active
  checkForTab() {
    $("body").keydown(function (e) {
      if (e.originalEvent.keyCode === 9) {
        $("body").addClass("outlines");
      }
    });
  }

  forms() {
    $("form input").focus(function () {
      let $this = $(this);
      $this.parent().addClass("active");
    });
    $("form input").blur(function () {
      let $this = $(this);
      if ($this.val() === "") {
        $this.parent().removeClass("active");
      }
    });

    let $form = $("form");
    $form.submit(function (event) {
      if (!$form.data("default")) {
        event.preventDefault();
        let data = $form.serialize();
        let action = $form.attr("action");
        $.ajax({
          type: "post",
          url: action ? action : "",
          data: data,
          crossDomain: true,
          headers: {
            accept: "application/javascript"
          },
          complete: function (response, textStatus) {
            console.log("Status: " + textStatus, response);
            if (response.status === 302 || response.status === 200) {
              $form.hide();
              $(".success-message").fadeIn();
            }
          }
        });
      }
    });
  }

  navigation() {
    $(".nav-trigger").click(function () {
      $("body").toggleClass("nav-active");
    });
  }

  jumpToTop() {
    let _this = this;
    $('a[href^="#"]').click(function (event) {
      event.preventDefault();
      let href = $(this).attr("href");
      if (href == "#jump-to-top") {
        $("html,body").animate({
            scrollTop: 0
          },
          1000
        );
      } else {
        let target = $(href).offset().top;
        $("html,body").animate({
            scrollTop: target
          },
          1000
        );
      }
    });
  }

  clearLast() {
    $(".clear-last").each(function () {
      const $q = $(this).find("> *");
      $q.eq($q.length - 1).addClass("last");
    });
  }

  familySection() {
    let range = 36,
      scale = 1.05;

    function generateNumber() {
      return Math.round(Math.random() * range - range / 2);
    }
    $(".family-section .feed .item").each(function () {
      const $this = $(this);
      let val = generateNumber();
      $this.find("img").css("transform", `rotate(${val}deg) scale(${scale})`);
      $this.hover(
        function () {
          let val = generateNumber();
          $this
            .find("img")
            .css("transform", `rotate(${val}deg) scale(${scale})`);
        },
        () => {}
      );
    });
  }

  generalMessage() {
    if (Cookies.get("general-message-accepted")) {
      // do nothing, message already accepted
    } else {
      $(".general-message").slideDown();
      $("body").addClass("has-general-message");
      $(".general-message .close").click(function () {
        $(".general-message").slideUp();
        $("body").removeClass("has-general-message");
        Cookies.set("general-message-accepted", true, {
          expires: 1
        });
      });
    }
  }
  fields() {
    $(".field").each(function () {
      const $el = $(this);
      $el.find("input").focus(function () {
        $el.addClass("active");
      });
      $el.find("input").blur(function () {
        if ($el.find("input").val()) {
          // ignore, maybe validate field
        } else {
          $el.removeClass("active");
        }
      });
    });
  }


  popups() {
    $(".popup").each(function () {
      const $el = $(this);
      const popupId = $el.data("id").trim();
      $el.attr("id", popupId);
      console.log(popupId);
      $el.remove();
      $("body").append($el);
      $(`a[href="#${popupId}"]`).off("click");
      $(`a[href="#${popupId}"]`).click(function () {
        $el.fadeIn();
      });

      $el.find(".close").click(function () {
        if (popupId == 'general-popup') {
          Cookies.set("general-popup-accepted", true, {
            expires: 1
          });
        }
        $el.fadeOut();
      });

      if ($el.find(".content").outerHeight(true) > window.innerHeight) {
        $el.addClass("has-overflow");
      }
    });

    if (Cookies.get("general-popup-accepted")) {
      // do nothing, message already accepted
    } else {
      $('a[href="#general-popup"]').click();
    }
  }

  halfHeightSections() {
    const $el = $(".half-height");

    function calc() {
      let min = 0;
      $el.css("min-height", min);
      $el.each(function () {
        const h = $(this).outerHeight();
        min = h > min ? h : min;
      });
      $el.css("min-height", min);
    }
    calc();
    $(window).resize(
      _.debounce(function () {
        calc();
      }, 250)
    );
  }

  menuSection() {
    $(".menu-section").each(function () {
      const $this = $(this);
      new ResponsiveUtility({
        phone: function () {
          let $sidebar = $this.find(".sidebar").remove();
          $this.find("header.menu-header").after($sidebar);
        },
        tablet: function () {
          let $sidebar = $this.find(".sidebar").remove();
          $this.find("header.menu-header").after($sidebar);
        },
        desktop: function () {
          let $sidebar = $this.find(".sidebar").remove();
          $this.find("> .left").append($sidebar);
        }
      });
    });
  }

  constructor() {
    this.checkForTab();
    this.addNoopener();
    this.navigation();
    this.forms();
    this.jumpToTop();
    this.clearLast();
    this.familySection();
    this.generalMessage();
    this.popups();
    this.fields();
    this.halfHeightSections();
    this.menuSection();
  }
}

module.exports = Global;